var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M407 164L407 192",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 407.5,
    cy: 159.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M402.987 159.19C402.987 155.283 406.288 152.117 410.358 152.117C410.943 152.117 411.511 152.184 412.056 152.308C410.742 151.48 409.187 151 407.519 151C402.814 151 399 154.806 399 159.5C399 164.194 402.814 168 407.519 168C409.814 168 411.895 167.093 413.427 165.62C412.492 166.032 411.454 166.263 410.358 166.263C406.288 166.263 402.987 163.096 402.987 159.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M416.402 158.6L416.37 156.146L414.535 157.719L412.304 157.056L413.112 159.337L411.765 161.381L414.1 161.218L415.499 163.144L416.133 160.763L418.345 159.909L416.402 158.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch4);
export default __webpack_public_path__ + "static/media/church_4.349a79373a7f2b4c787bb4d218d3626f.svg";
export { ForwardRef as ReactComponent };